import React, { useState, useEffect } from "react";

const Spinner = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default Spinner;
